import {
  Box,
  AccordionButton as ChakraAccordionButton,
  AccordionButtonProps as ChakraAccordionButtonProps,
  ComponentStyleConfig,
  StyleProps,
  useStyleConfig,
} from '@chakra-ui/react';
import { AccordionIcon } from '../AccordionIcon';

export type AccordionButtonProps = ChakraAccordionButtonProps;

const AccordionButtonStyles: ComponentStyleConfig = {
  baseStyle: {
    bg: 'base2Colour.500',
    color: 'base2FontColour.500',
    _hover: {
      bg: 'base2Colour.500',
    },
  },
};

const AccordionButton = ({ children, ...props }: AccordionButtonProps) => {
  const styles = useStyleConfig('AccordionButton');

  // Can't use _css here as it breaks default functionality
  return (
    <ChakraAccordionButton {...(styles as StyleProps)} {...props}>
      <Box as="span" flex="1" textAlign="left">
        {children}
      </Box>
      <AccordionIcon />
    </ChakraAccordionButton>
  );
};

export { AccordionButton, AccordionButtonStyles };
